import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export function useConfig() {
  const [config, setConfig] = useState(cache);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    if (cache) return;
    api
      .get("/config")
      .then((r) => {
        cache = r.data;
        setConfig(r.data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return { config, loading };
}
